import { BarthelKey, HeadToToeKey } from "@/types/asesmen_geriatri";

export interface OpsiSkor {
  value: number;
  text: string;
}

export interface KatalogItem {
  key: string;
  label: string;
}

export const KELUHAN_UTAMA_ITEMS: KatalogItem[] = [
  { key: "jatuh", label: "Jatuh" },
  { key: "sering_jatuh", label: "Sering Jatuh" },
  { key: "tirah_baring", label: "Tirah Baring" },
  { key: "pusing", label: "Pusing" },
  { key: "bingung", label: "Bingung" },
  { key: "tidak_mau_makan", label: "Tidak Mau Makan" }
];

export const KELUHAN_UTAMA_LEGACY_ITEMS: KatalogItem[] = [
  { key: "jatuh_tirah_baring", label: "Jatuh / Tirah Baring" },
  { key: "pusing_bingung", label: "Pusing / Bingung" }
];

export interface HeadToToeRow {
  key: HeadToToeKey;
  label: string;

  catatan: string;
  options: KatalogItem[];
}

export const HEAD_TO_TOE_ROWS: HeadToToeRow[] = [
  {
    key: "kepala_rambut",
    label: "Kepala & Rambut",
    catatan: "Kelainan / Lainnya",
    options: [
      { key: "normal", label: "Normal" },
      { key: "kelainan", label: "Kelainan / Lainnya" }
    ]
  },
  {
    key: "mata",
    label: "Mata",
    catatan: "Catatan",
    options: [
      { key: "normal", label: "Normal" },
      { key: "konjungtiva_anemis", label: "Konjungtiva anemis" },
      { key: "sklera_ikterik", label: "Sklera ikterik" },
      { key: "gangguan_penglihatan", label: "Gangguan penglihatan" },
      { key: "kaca_mata", label: "Kaca mata" },
      { key: "katarak", label: "Katarak" }
    ]
  },
  {
    key: "telinga",
    label: "Telinga",
    catatan: "Catatan",
    options: [
      { key: "normal", label: "Normal" },
      { key: "serumen", label: "Serumen" },
      { key: "penurunan_pendengaran", label: "Penurunan pendengaran" },
      { key: "alat_bantu_dengar", label: "Alat bantu dengar" }
    ]
  },
  {
    key: "hidung_tenggorokan",
    label: "Hidung & Tenggorokan",
    catatan: "Sekret",
    options: [
      { key: "normal", label: "Normal" },
      { key: "mukosa_hiperemis", label: "Mukosa hiperemis" },
      { key: "sekret", label: "Sekret" }
    ]
  },
  {
    key: "gigi_mulut",
    label: "Gigi & Mulut",
    catatan: "Catatan",
    options: [
      { key: "ompong_total", label: "Ompong total" },
      { key: "gigi_palsu", label: "Memakai gigi palsu" },
      { key: "karang_gigi_rusak", label: "Ada karang / gigi rusak" }
    ]
  },
  {
    key: "leher",
    label: "Leher",
    catatan: "Catatan",
    options: [
      { key: "jvp_normal", label: "JVP normal" },
      { key: "kgb_ada", label: "Pembesaran kelenjar getah bening: Ada" },
      { key: "kgb_tidak_ada", label: "Tidak ada" }
    ]
  },
  {
    key: "thorax_paru",
    label: "Thorax / Paru",
    catatan: "Lainnya",
    options: [
      { key: "simetris", label: "Simetris" },
      { key: "vesikuler", label: "Vesikuler" },
      { key: "ronkhi", label: "Ronkhi" },
      { key: "wheezing", label: "Wheezing" },
      { key: "lainnya", label: "Lainnya" }
    ]
  },
  {
    key: "jantung",
    label: "Jantung",
    catatan: "Lainnya",
    options: [
      { key: "s1_s2_tunggal", label: "S1/S2 tunggal" },
      { key: "murmur", label: "Murmur" },
      { key: "gallop", label: "Gallop" },
      { key: "lainnya", label: "Lainnya" }
    ]
  },
  {
    key: "abdomen",
    label: "Abdomen",
    catatan: "Hepar / Lien teraba",
    options: [
      { key: "supel", label: "Supel" },
      { key: "nyeri_tekan", label: "Nyeri tekan" },
      { key: "bising_usus_normal", label: "Bising usus normal" },
      { key: "hepar_lien_teraba", label: "Hepar / Lien teraba" },
      { key: "kembung", label: "Kembung" },
      { key: "asites", label: "Asites" }
    ]
  },
  {
    key: "ekstremitas",
    label: "Ekstremitas",
    catatan: "Deformitas",
    options: [
      { key: "akral_hangat", label: "Akral hangat" },
      { key: "edema", label: "Edema" },
      { key: "deformitas", label: "Deformitas" }
    ]
  },
  {
    key: "kulit",
    label: "Kulit",
    catatan: "Catatan",
    options: [
      { key: "turgor_baik", label: "Turgor baik" },
      { key: "decubitus_ada", label: "Lesi - Decubitus: Ada" },
      { key: "decubitus_tidak_ada", label: "Tidak ada" }
    ]
  }
];

export interface KognitifField {
  key: string;
  label: string;
  uji: string;
  max: number;
}

export const KOGNITIF_FIELDS: KognitifField[] = [
  {
    key: "orientasi",
    label: "Orientasi Waktu & Tempat",
    uji: "Sebutkan: tahun, bulan, tanggal, hari, nama gedung/pos",
    max: 10
  },
  {
    key: "registrasi",
    label: "Registrasi Memori",
    uji: "Ulangi sebutan 3 kata: Bola, Meja, Pensil",
    max: 3
  },
  {
    key: "atensi_kalkulasi",
    label: "Atensi / Kalkulasi",
    uji: "Hitung mundur 100 dikurangi 7 sebanyak 5 tingkat",
    max: 5
  },
  {
    key: "recall",
    label: "Recall",
    uji: "Sebutkan lagi 3 kata di atas setelah jeda",
    max: 3
  },
  {
    key: "bahasa_perintah",
    label: "Bahasa & Perintah",
    uji: "Menamai jam tangan/pulpen, ulangi kalimat, ikuti perintah 3 tahap",
    max: 9
  }
];

export interface BarthelField {
  key: BarthelKey;
  label: string;
  options: OpsiSkor[];
}

export const BARTHEL_FIELDS: BarthelField[] = [
  {
    key: "makan",
    label: "Makan",
    options: [
      { value: 0, text: "Tergantung" },
      { value: 5, text: "Dibantu" },
      { value: 10, text: "Mandiri" }
    ]
  },
  {
    key: "mandi",
    label: "Mandi",
    options: [
      { value: 0, text: "Tergantung" },
      { value: 5, text: "Mandiri" }
    ]
  },
  {
    key: "berhias",
    label: "Berhias",
    options: [
      { value: 0, text: "Dibantu" },
      { value: 5, text: "Mandiri" }
    ]
  },
  {
    key: "berpakaian",
    label: "Berpakaian",
    options: [
      { value: 0, text: "Tergantung" },
      { value: 5, text: "Dibantu sebagian" },
      { value: 10, text: "Mandiri" }
    ]
  },
  {
    key: "bak",
    label: "Kontrol BAK",
    options: [
      { value: 0, text: "Inkontinensia / tidak teratur" },
      { value: 5, text: "Kadang Inkontinensia (sekali seminggu)" },
      { value: 10, text: "Teratur" }
    ]
  },
  {
    key: "bab",
    label: "Kontrol BAB",
    options: [
      { value: 0, text: "Inkontinensia / tidak teratur" },
      { value: 5, text: "Kadang Inkontinensia (sekali seminggu)" },
      { value: 10, text: "Teratur" }
    ]
  },
  {
    key: "toilet",
    label: "Ke Toilet",
    options: [
      { value: 0, text: "Tergantung" },
      { value: 5, text: "Dibantu sebagian" },
      { value: 10, text: "Mandiri" }
    ]
  },
  {
    key: "transfer",
    label: "Transfer Kursi-Kasur",
    options: [
      { value: 0, text: "Tidak mampu" },
      { value: 5, text: "Bantuan kuat" },
      { value: 10, text: "Bantuan minim" },
      { value: 15, text: "Mandiri" }
    ]
  },
  {
    key: "berjalan",
    label: "Berjalan",
    options: [
      { value: 0, text: "Imobilisasi" },
      { value: 5, text: "Kursi roda" },
      { value: 10, text: "Dibantu 1 orang" },
      { value: 15, text: "Mandiri" }
    ]
  },
  {
    key: "tangga",
    label: "Naik Tangga",
    options: [
      { value: 0, text: "Tidak mampu" },
      { value: 5, text: "Butuh bantuan" },
      { value: 10, text: "Mandiri" }
    ]
  }
];

export interface SkorField {
  key: string;
  label: string;
  kriteria: string;
  options: OpsiSkor[];
}

export const NUTRISI_FIELDS: SkorField[] = [
  {
    key: "asupan_makanan",
    label: "Asupan Makanan",
    kriteria: "Apakah asupan makanan kurang karena penurunan nafsu makan / mengunyah?",
    options: [
      { value: 0, text: "0 = Asupan makanan sangat berkurang" },
      { value: 1, text: "1 = Asupan makanan agak berkurang" },
      { value: 2, text: "2 = Asupan makanan tidak berkurang" }
    ]
  },
  {
    key: "kehilangan_bb",
    label: "Kehilangan BB",
    kriteria: "Apakah pasien kehilangan BB secara tidak sengaja dalam 2 bulan terakhir?",
    options: [
      { value: 0, text: "0 = Penurunan berat badan > 3 kg" },
      { value: 1, text: "1 = Tidak tahu" },
      { value: 2, text: "2 = Penurunan berat badan antara 1 - 3 kg" },
      { value: 3, text: "3 = Tidak ada penurunan berat badan" }
    ]
  },
  {
    key: "mobilitas",
    label: "Mobilitas",
    kriteria: "Kemampuan pasien bergerak, dari mandiri hingga terbatas di tempat tidur/kursi.",
    options: [
      { value: 0, text: "0 = Terbatas di tempat tidur atau kursi" },
      { value: 1, text: "1 = Mampu bangun dari tempat tidur/kursi, tapi tidak bisa bepergian ke luar rumah" },
      { value: 2, text: "2 = Dapat bepergian ke luar rumah" }
    ]
  },
  {
    key: "psikologis",
    label: "Psikologis",
    kriteria: "Menderita stres psikologis atau penyakit akut selama 3 bulan terakhir?",
    options: [
      { value: 0, text: "0 = Ya" },
      { value: 1, text: "1 = Tidak" }
    ]
  },
  {
    key: "neurologis",
    label: "Neurologis",
    kriteria: "Masalah neuropsikologis?",
    options: [
      { value: 0, text: "0 = Demensia atau depresi berat" },
      { value: 1, text: "1 = Demensia ringan" },
      { value: 2, text: "2 = Tidak ada masalah psikologis" }
    ]
  },
  {
    key: "imt",
    label: "IMT",
    kriteria: "Indeks Masa Tubuh (Berat Badan dalam kg / Tinggi Badan dalam meter kuadrat)",
    options: [
      { value: 0, text: "0 = IMT < 19" },
      { value: 1, text: "1 = IMT 19 - <21" },
      { value: 2, text: "2 = IMT 21 - <23" },
      { value: 3, text: "3 = IMT ≥ 23" }
    ]
  },
  {
    key: "lila",
    label: "LILA",
    kriteria: "Pengukuran LILA pada lansia",
    options: [
      { value: 0, text: "0 = < 21" },
      { value: 0.5, text: "0,5 = 21 - 22" },
      { value: 1, text: "1 = > 22" }
    ]
  }
];

export const RISIKO_JATUH_FIELDS: SkorField[] = [
  {
    key: "riwayat_jatuh",
    label: "Riwayat Jatuh",
    kriteria:
      "Apakah pasien masuk RS karena jatuh atau pernah jatuh dalam 2 bulan terakhir?",
    options: [
      { value: 0, text: "Tidak (0)" },
      { value: 6, text: "Ya (6)" }
    ]
  },
  {
    key: "status_mental",
    label: "Status Mental",
    kriteria: "Apakah pasien mengalami delirium, disorientasi, atau agitasi?",
    options: [
      { value: 0, text: "Tidak (0)" },
      { value: 14, text: "Ya (14)" }
    ]
  },
  {
    key: "gangguan_penglihatan_berat",
    label: "Penglihatan",
    kriteria:
      "Apakah pasien memakai kacamata, penglihatan buram, atau memiliki riwayat katarak/glaukoma?",
    options: [
      { value: 0, text: "Tidak (0)" },
      { value: 1, text: "Ya (1)" }
    ]
  },
  {
    key: "kebiasaan_berkemih",
    label: "Kebiasaan Berkemih",
    kriteria:
      "Apakah ada perubahan pola berkemih (sering, mendesak, inkontinensia/ompol)?",
    options: [
      { value: 0, text: "Tidak (0)" },
      { value: 2, text: "Ya (2)" }
    ]
  },
  {
    key: "transfer",
    label: "Transfer",
    kriteria:
      "Kemandirian bergerak dari tempat tidur ke kursi dan kembali lagi ke tempat tidur",
    options: [
      { value: 0, text: "Mandiri (boleh memakai alat bantu jalan) (0)" },
      {
        value: 1,
        text: "Memerlukan sedikit bantuan (1 orang) / dalam pengawasan (1)"
      },
      { value: 2, text: "Memerlukan bantuan yang nyata (2 orang) (2)" },
      {
        value: 3,
        text: "Tidak dapat duduk dengan seimbang, perlu bantuan total (3)"
      }
    ]
  },
  {
    key: "mobilitas",
    label: "Mobilitas",
    kriteria: "Kemandirian bergerak dan gaya berjalan pasien",
    options: [
      { value: 0, text: "Mandiri (boleh menggunakan alat bantu jalan) (0)" },
      { value: 1, text: "Berjalan dengan bantuan 1 orang (verbal / fisik) (1)" },
      { value: 2, text: "Menggunakan kursi roda (2)" },
      { value: 3, text: "Imobilisasi (3)" }
    ]
  }
];

export const RISIKO_JATUH_MOBILITAS_KEYS = ["transfer", "mobilitas"];

export const MASALAH_ITEMS: KatalogItem[] = [
  { key: "delirium", label: "Delirium" },
  { key: "falls", label: "Falls" },
  { key: "immobility", label: "Immobility" },
  { key: "incontinence", label: "Incontinence" },
  { key: "malnutrition", label: "Malnutrition" }
];

export const SINDROM_ITEMS: KatalogItem[] = [
  { key: "malnutrisi", label: "Malnutrisi" },
  { key: "polifarmasi", label: "Polifarmasi" },
  { key: "fall_risk", label: "Fall Risk" },
  { key: "pressure_ulcer", label: "Pressure Ulcer" },
  { key: "cognitive_impairment", label: "Cognitive Impairment" },
  { key: "frailty", label: "Frailty" },
  { key: "incontinence", label: "Incontinence" }
];

export interface IntervensiGroup {
  key: string;
  label: string;
  options: KatalogItem[];
}

export const INTERVENSI_GROUPS: IntervensiGroup[] = [
  {
    key: "medis",
    label: "Medis / Penyakit Dalam",
    options: [
      { key: "penyesuaian_dosis_obat", label: "Penyesuaian dosis obat" },
      { key: "stop_polifarmasi", label: "Stop polifarmasi" },
      { key: "tambahan_terapi", label: "Tambahan terapi" }
    ]
  },
  {
    key: "rehab_medik",
    label: "Rehabilitasi Medik",
    options: [
      {
        key: "get_up_and_go_exercise",
        label: "Latihan kawasan bangun fisik (Get up and go exercise)"
      }
    ]
  },
  {
    key: "gizi_klinik",
    label: "Gizi Klinik",
    options: [
      { key: "diet_tktp", label: "Diet tinggi kalori tinggi protein" },
      { key: "bentuk_cair", label: "Bentuk cair" },
      { key: "bentuk_lunak", label: "Bentuk lunak" }
    ]
  },
  {
    key: "keperawatan",
    label: "Keperawatan",
    options: [
      {
        key: "gelang_risiko_jatuh_kuning",
        label: "Pemasangan gelang risiko jatuh warna kuning"
      },
      { key: "edukasi_caregiver", label: "Edukasi caregiver" }
    ]
  }
];
